import { router } from ".";
import { guards } from "@/guards";
const salesManagementRoutes = [
  {
    path: "/sales-management",
    name: "SalesManagement",
    component: () =>
      import("../views/dashboard/SalesManagement/SalesManagement.vue"),
    beforeEnter: () =>
      guards.isAdministrator() ||
      guards.isSalesClerk() ||
      router.push({ name: "Unauthorized" }),
  },
  {
    path: "/sales-report",
    name: "SalesReport",
    component: () =>
      import("../views/dashboard/SalesManagement/SalesReport.vue"),
    beforeEnter: () =>
      guards.isAdministrator() ||
      guards.isSalesClerk() ||
      router.push({ name: "Unauthorized" }),
  },
  {
    path: "/returns-report",
    name: "ReturnsReport",
    component: () =>
      import("../views/dashboard/SalesManagement/ReturnsReport.vue"),
    beforeEnter: () =>
      guards.isAdministrator() ||
      guards.isSalesClerk() ||
      router.push({ name: "Unauthorized" }),
  },
];
export { salesManagementRoutes };
